module.exports = __webpack_public_path__ + "img/tag.f22ee36c.png";